import { render, staticRenderFns } from "./popInput.vue?vue&type=template&id=3352c6a4&scoped=true"
import script from "./popInput.vue?vue&type=script&lang=js"
export * from "./popInput.vue?vue&type=script&lang=js"
import style0 from "./popInput.vue?vue&type=style&index=0&id=3352c6a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3352c6a4",
  null
  
)

export default component.exports